import { AddFeatureButton } from 'features/siteMap/popupMenus/editMode/plusMenu/AddFeatureButton'
import { EditSiteConfigButton } from 'features/siteMap/popupMenus/editMode/plusMenu/EditSiteConfigButton'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const MenuContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  flex-direction: column;
  align-items: end;
  gap: 8px;
  margin: 20px 10px;
  height: ${({ $isOpen }) => ($isOpen ? '80px' : '70px')};
  transition: height 200ms;
`

interface MapPlusMenuProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  setShowEditSiteConfigPopupMenu: Dispatch<SetStateAction<Vector2 | undefined>>
}

export const MapPlusMenu: FC<MapPlusMenuProps> = (props) => {
  return (
    <MenuContainer $isOpen={props.isOpen}>
      <EditSiteConfigButton
        closeMenu={() => props.setIsOpen(false)}
        setShowEditSiteConfigPopupMenu={props.setShowEditSiteConfigPopupMenu}
      />
      <AddFeatureButton closeMenu={() => props.setIsOpen(false)} />
    </MenuContainer>
  )
}
